module.exports = Object.freeze({
  Zone: {
    flagPresaleEnabled: 1,
    flagLongPresaleEnabled: 2,
    flagCumulativeResetInDayEnabled: 4,
    flagCutAtMidnight: 8,
    flagDivideFirstUnitToHalf: 16,
    DayOff: {
      typeHolidays: 'holidays',
      typeUnavailableDays: 'unavailable_days',
      actionAdd: 'add',
      actionRemove: 'remove',
      predefinedList: ['01.01.', '06.01.', '01.05.', '08.05.', '05.07.', '29.08.', '15.09.', '01.11.', '24.12.', '25.12.', '26.12.'],
    },
  },
  City: {
    flagVatEnabled: 1,
  },
  Ticket: {
    typeSystemTicket: 'systemTicket'
  }
})